import React, { useEffect, useState } from 'react'
import { module as user } from "@st/user";
import { connectStore } from "redux-box";
import { module as onboard } from "@st/onboard";
import { module as ui } from "@st/ui";

import './AssignFreadomTeacher.css'
import { ThemeButton } from '../../../../static/styled/custom.styled';
import Select from 'react-select'

const AssignFreadomTeacher = (props) => {
  const [section, setSection] = useState([])
  const [sectionsList, setSectionsList] = useState([])

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "relative"
    }),
  };

  useEffect(() => {
    let schoolclassList = []
    if (props.user.active_child && props.user.active_child.school_class) {
      const activeClasses = Array.isArray(props.user.active_child.school_class)
        ? props.user.active_child.school_class
        : [props.user.active_child.school_class];

      const teacherId = props.user.active_child.teacher;
      let difference = activeClasses.filter((sc) => sc.teacher !== teacherId);

      if (difference.length > 0) {
        difference.forEach((sc) => {
          schoolclassList.push({
            label: sc.name,
            value: sc.id
          })
        })
      } else {
        activeClasses.forEach((sc) => {
          schoolclassList.push({
            label: sc.name,
            value: sc.id
          })
        })
      }
      setSectionsList(schoolclassList)
    }
  }, [props.user.active_child])

  const handleAssignFreadomTeacher = async () => {
    if (section.length === 0) {
      alert("Please select at least one section")
      return
    }
    const data = {
      is_freadom_teacher: true,
      child: props.user.active_child.id,
      school_class: section.map((sec) => sec.value),
      class_type: 'FFS'
    }
    await props.user.updateFreadomTeacher(data)
    props.ui.hideModal()
  }

  return (
    <div className='link_school_code_form'>
      <React.Fragment>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Sections</label>
          <Select
            className="dropdown-container"
            isMulti={true}
            value={section}
            onChange={(selectedSection) => setSection(selectedSection || [])}
            options={sectionsList && sectionsList}
            placeholder="Select Section"
            styles={customStyles}
          />
        </div>

        <ThemeButton primary onClick={() => handleAssignFreadomTeacher()}
          type="button" className="link_school_code_form_btn">Assign as Teacher</ThemeButton>
      </React.Fragment>
    </div>
  )
}

export default connectStore({
  user,
  onboard,
  ui
})(AssignFreadomTeacher);
